<<!-- upsome -->
<template>
  <div>
    <div class="up-mask" v-if="dialogVisible">
      <i class="el-dialog__close el-icon el-icon-close up-close" @click="hideImg"></i>
      <img width="100%" :src="dialogImageUrl" alt class="center-img">
    </div>
    <!-- :class="{{file_list.length>3?'tool-disabled':''}}" -->
    <el-upload
      :class="disabled?'tool-disabled':''"
      accept="image/jpeg, image/png, image/jpg"
      :disabled="disabled"
      :action="api.upload_img"
      name="filename"
      :file-list="file_list"
      :before-upload="fileBefore"
      :on-success="fileSuccess"
      :on-remove="handleRemove"
      :on-preview="handlePictureCardPreview"
      :on-error="fileErr"
      list-type="picture-card"
      :limit="limits"
      :on-exceed="fileExceed"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
     <!-- <el-dialog :visible.sync="show" >
      <div>1</div>
    </el-dialog> -->
  </div>
</template>

<script>
import conf from "../../config/api";
import cook from "../../utils/http";
export default {
  props: ["file_list", "type", "disabled",'limits'],
  name: "upsome",
  data() {
    return {
      api: {
        upload_img:
          conf.api +
          "home/upload_img?auth_token=" +
          cook.cookie.get("auth_token")
      },
      dialogVisible: false,
      dialogImageUrl: "",
      // show:true

    };
  },
  components: {},
  created() {
    console.log(this.disabled)
  },
  mounted() {},
  methods: {
    fileBefore(file) {
      let size = file.size / 1024 / 1024 < 2;
      if (!size) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
    },
    fileSuccess(response, file, fileList) {
      // debugger
      if (this.type != 1) {
        this.$emit("getPic", file.response.data.pic);
      } else {
        let list = [];
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response) {
            list.push(fileList[i].response.data.url);
          } else {
            list.push(fileList[i].url);
          }
        }
        this.$emit("getPic", list.join(","));
      }
    },
    handleRemove(file, fileList) {
      if (this.type != 1) {
        this.$emit("getPic", "");
      } else {
        let list = [];
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response) {
            list.push(fileList[i].response.data.url);
          } else {
            list.push(fileList[i].url);
          }
        }
        this.$emit("getPic", list.join(","));
      }
    },
    handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    hideImg() {
      this.dialogVisible = false;
    },
    //图片上传失败
    fileErr(err, file, fileList) {
      this.$message.error("上传失败");
    },
    fileExceed(file, fileList) {
      this.$message.warning(`最多上传${this.limits}张`)
    }
  }
};
</script>
<style  scoped>
.center-img {
  position: absolute;
  width: 500px;
  /* height: 300px; */
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.up-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}
.up-close {
  position: absolute;
  right: 33px;
  top: 20px;
  color: #fff;
  font-size: 40px;
  cursor: pointer;
}

</style>